import { cn } from "../../lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  // Neutral grey instead of the brand-tinted `primary/10`. `bg-muted` is the
  // theme-aware grey token from shadcn — light grey on light themes, darker
  // grey on dark — so skeletons read as loading shimmers rather than as
  // tinted placeholders that get confused for real UI.
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
